import {observable, action} from 'mobx';

class Structure {
  id = null;

  @observable name;

  @observable nameZh;

  @observable nameEn;

  parentId;

  hasUser;

  @observable hasAsset;

  @observable children;

  @observable path = [];

  @observable isAutoDispatch;

  @observable isLeaf;

  nameJson;

  constructor(store, id, name) {
    this.store = store;
    this.id = id;
    this.name = name;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.isAutoDispatch = json.isAutoDispatch;
  }

  updateStructureTreeFromJson(json) {
    this.name = json.name;
    this.nameZh = json.nameZh;
    this.nameEn = json.nameEn;
    this.children = [];
    this.isLeaf = json.isLeaf;
    this.isAssigned = json.isAssigned;
    this.parentId = json.parentId;
    this.hasAsset = json.hasAsset;
  }

  updateStructureTreeFromJson2(json) {
    this.name = json.name;
    this.children = [];
    this.isLeaf = json.isLeaf;
    this.hasAdminPermission = json.hasAdminPermission;
  }

  updateStructureTreeFromJson3(json) {
    this.name = json.name;
    this.children = json.children;
  }

  @action
  updateStructureDetailFromJson(json) {
    this.name = json.name;
    this.nameZh = json.nameZh;
    this.nameEn = json.nameEn;
    this.parentId = json.parentId;
    this.hasUser = json.hasUser;
    this.hasAsset = json.hasAsset;
    this.children = json.children;
    this.isLeaf = json.isLeaf;
    this.nameJson = json.nameJson;
  }

  updateStructurePathFromJson(json) {
    this.path = json.path;
  }
}

export default Structure;
